import React from 'react';
import { TileLayer } from 'react-leaflet';

// Renders the tile layer(s) for the chosen basemap.
// 'satellite' uses free Esri World Imagery + a labels/roads reference overlay (Google-hybrid look).
export function BasemapLayers({ basemap }) {
  if (basemap === 'satellite') {
    return (
      <>
        <TileLayer
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
          attribution="Esri, Maxar, Earthstar Geographics"
          maxZoom={19}
        />
        <TileLayer
          url="https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}"
          maxZoom={19}
        />
      </>
    );
  }
  return (
    <TileLayer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      attribution="&copy; OpenStreetMap"
    />
  );
}

// Small Street/Satellite toggle overlaid on the map.
export function BasemapToggle({ basemap, setBasemap }) {
  return (
    <div className="map-basemap-toggle">
      <button
        type="button"
        className={basemap === 'street' ? 'active' : ''}
        onClick={() => setBasemap('street')}
      >
        Street
      </button>
      <button
        type="button"
        className={basemap === 'satellite' ? 'active' : ''}
        onClick={() => setBasemap('satellite')}
      >
        Satellite
      </button>
    </div>
  );
}
